<template>
  <div class="box-header">
    <div class="box-container">
      <div class="flex justify-between items-center">
        <h3 class="avenir text-xl font-bold mt-2">{{$t('shared.booking_summary')}}</h3>
      </div>
      <hr class="hr-col mt-2 mb-4" />
      <template
        class="flex justify-between items-center my-2"
        v-for="(item, index) in newExtras"
      >
        <div v-if="item" :key="index">
          <div class="flex justify-between items-center">
            <p>{{ item.title }} x{{ item.quantity }}:</p>
            <p>{{ item.pivot ? item.pivot.price : item.price }} €</p>
          </div>
        </div>
      </template>
      <template
        class="flex justify-between items-center my-2"
        v-for="passenger in newPassengers"
      >
        <div v-if="passenger.bags" :key="passenger.id">
          <div
            v-for="(bag, index) in passenger.bags"
            :key="index"
            class="flex justify-between items-center"
          >
            <div v-if="passenger" class="flex justify-between items-center">
              <p>{{ bag.name }} ({{ passenger.name }}):</p>
              <p>{{ bag.price | currency }}</p>
            </div>
            <hr />
          </div>
        </div>
      </template>

      <div v-if="newPassengers.bags > 0 || newExtras.length > 0">
        <hr class="hr-col mt-2 mb-4" />
      </div>
      <div class="flex justify-between items-center my-2">
        <p class="avenir text-xl font-bold">{{$t('shared.total')}}:</p>
        <p class="code-res text-xl font-bold">{{ totalBonus | currency }}</p>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { mapGetters } from "vuex";
import {
  NIGHTS_GET_EXTRA_BY_ID,
  NIGHTS_GET_EXTRA_UNIT_PRICE,
  NIGHTS_GET_PASSENGERS_COUNT,
  NIGHTS_GET_SELECTED_EXTRA_BY_ID
} from "../store/nights/getter-types";
import {
  GET_RESERVATION_CODE,
  GET_RESERVATION,
  GET_AVALIABLE_EXTRAS,
  GET_NEW_PASSENGERS,
  GET_NEW_EXTRAS,
  GET_TOTAL_BONUS
} from "../store/reserve-area/getter-types";
import {
  NIGHTS_SET_EXTRA_QUANTITY,
  NIGHTS_TOGGLE_EXTRA
} from "../store/nights/mutation-types";
import { GET_PASSENGERS } from "../store/reserve-area/getter-types";
import passengerLabel from "../utils/mixins/passengerLabel";
import BagsComponent from "./../pages/nights/common/BagsComponent.vue";
import { SET_TERMS } from "../store/booking/mutation-types";
import { GET_TERMS } from "../store/booking/getter-types";
import { SET_STEPPER_LOADING } from "../store/stepper/mutation-types";
import { GET_PAYMENT_METHOD } from "../store/getter-types";

export default {
  components: {
    BagsComponent
  },
  mixins: [passengerLabel],
  data() {
    return {
      showPaypal: false,
      showOverlay: false
    };
  },
  computed: {
    extras() {
      return this.$store.state.nights.resources.extras;
    },
    extrasBags() {
      return this.$store.state.nights.resources.bags;
    },
    terms() {
      return this.$store.getters[GET_TERMS].terms.value;
    },
    paymentMethod() {
      return this.$store.getters[GET_PAYMENT_METHOD];
    },
    ...mapGetters({
      getPassengersCount: NIGHTS_GET_PASSENGERS_COUNT,
      getExtraById: NIGHTS_GET_EXTRA_BY_ID,
      getSelectedExtraById: NIGHTS_GET_SELECTED_EXTRA_BY_ID,
      getExtraPrice: NIGHTS_GET_EXTRA_UNIT_PRICE,
      passengers: GET_PASSENGERS,
      reservationCode: GET_RESERVATION_CODE,
      reservation: GET_RESERVATION,
      extrasAvaliable: GET_AVALIABLE_EXTRAS,
      newPassengers: GET_NEW_PASSENGERS,
      newExtras: GET_NEW_EXTRAS,
      totalBonus: GET_TOTAL_BONUS
    }),
    extrasToAdd() {
      return this.extrasAvaliable.filter(extrasAvaliable =>
        this.reservation.extras.every(extraAdded => {
          if (extraAdded.one_per_passenger) {
            return extraAdded.id != extrasAvaliable.id;
          } else {
            return extraAdded.pivot.quantity < this.total_passengers;
          }
        })
      );
    }
  },
  methods: {
    extraQuantity(extraId) {
      const extra = this.getSelectedExtraById(extraId);
      if (!extra) return 0;
      return extra.has_counter ? extra.quantity : 0;
    },
    toggleExtra(extraId) {
      this.$store.commit(NIGHTS_TOGGLE_EXTRA, extraId);
    },
    changeExtraQuantity(quantity, extraId) {
      this.$store.commit(NIGHTS_SET_EXTRA_QUANTITY, { quantity, extraId });
    },
    validate() {
      return this.validateTerms();
    },
    validateTerms() {
      this.$store.commit(SET_TERMS, {
        ...this.$store.getters[GET_TERMS],
        terms: {
          error: !this.terms,
          value: this.terms
        }
      });
      if (!this.terms) {
        this.$toastr.e("Debes aceptar los términos y condiciones");
      }
      return this.terms;
    },
    retrievePaymentParameters() {
      this.$refs.paymentMethods.$refs.redsysComponent.retrievePaymentParameters();
    },
    submit() {
      if (!this.validate()) {
        this.$store.dispatch(SET_STEPPER_LOADING, false);
        return;
      }

      if (this.paymentMethod == "paypal") {
        this.showPaypal = true;
        this.showOverlay = true;
        const paypalContainer = document.getElementById("submitContainer");

        window.scrollTo({
          top: paypalContainer.offsetTop,
          left: 0,
          behavior: "smooth"
        });
      } else this.retrievePaymentParameters();
    },
    scrollToBottom() {
      if (window.matchMedia("(min-width: 1280px)").matches) {
        window.scrollTo(0, 9999);
      }
    }
  }
};
</script>
<style lang="scss">
@import "../../sass/variables";

.box-header {
  overflow: hidden;
  background-color: $white;
  border-radius: 15px;
  border: 1px solid $brownGrey;
  .box-container {
    padding: 1.8rem 16px;
    &:first-of-type {
      padding-top: 1.1rem;
      padding-bottom: 1.1rem;
      border-bottom: 1px solid $brownGrey;
    }
    @media (min-width: 640px) {
      padding: 1.8rem 2.2rem;
    }
  }
  &.no-header {
    .box-container:first-of-type {
      border-bottom: none;
    }
  }
  .hr-col {
    background-color: #979797;
  }
}
</style>
